@use "variables" as *;

.statsLabel {
  font-size: $fontSize-s;
  font-variant: tabular-nums !important;
  padding: $spacing-xs;
}
